var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import RenderIf from 'syf-component-library/ui/atoms/RenderIf';
import { Stack } from 'syf-component-library/ui/spacing';
import useRadioGroupFocusRef from '../../../hooks/use-radio-group-focus-ref';
import { StyledAnswers, StyledRadio } from './subcomponents';
export var Answers = function (_a) {
    var answers = _a.answers, selectedAnswers = _a.selectedAnswers, onChange = _a.onChange;
    var radioGroupRef = useRadioGroupFocusRef();
    var isChecked = function (answerId) {
        return Boolean(selectedAnswers.find(function (item) { return item.answerId === answerId; }));
    };
    return (_jsxs(StyledAnswers, __assign({ ref: radioGroupRef }, { children: [_jsx(Stack, { size: "large" }), _jsx(RenderIf, __assign({ condition: !!answers.length }, { children: _jsx(_Fragment, { children: answers.map(function (item) { return (_jsx(StyledRadio, __assign({ id: item.answerId, name: "groupName", value: item.answerId, onChange: function () { return onChange(item); }, checked: isChecked(item.answerId) }, { children: item.answer }), item.answerId)); }) }) })), _jsx(Stack, { size: "large" })] })));
};
//# sourceMappingURL=index.js.map